import { faCog } from '@fortawesome/pro-light-svg-icons'
import { ProductAddonTypeTyInversed, ProductAddonTypeTyKeys } from '@teinor/erp/types/company/config/parameter'
import { useCallback } from 'react'
import { ITIconToolTip } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { ITLayoutTableModalOpenSetTy } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/types'
import { InputTableLayoutData } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import { RowData } from '../../../../../../../baseComponents/TwinTable/types'
import { ParameterValueType } from '../../../../../../../baseComponents/TwinTable/VirtualTableListing/Subcomponents/types'
import useOrderProductAddonModal from '../../../../../../../utils/hooks/orders/useOrderProductAddonModal'
import useTwinTranslation from '../../../../../../../utils/hooks/useTwinTranslation'
import { getConfigParam } from '../../../../../../../utils/reducers/getters'


export interface OrderEditAddonProductProps {
    setOpenModal: ITLayoutTableModalOpenSetTy
    value: ParameterValueType,
    allRowData: RowData
    completeData: InputTableLayoutData | null
}

const OrderEditAddonProduct: React.FC<OrderEditAddonProductProps> = ({ setOpenModal, allRowData, completeData }) => {
    const {t} = useTwinTranslation()
    const orderProductAddonModal = useOrderProductAddonModal()
    const productAddonType: ProductAddonTypeTyKeys = allRowData?.['Product.productAddonType'] || allRowData?.['Product.Product.CategoriesProducts.Category.productAddonType'] || getConfigParam('productAddonType')
    const myOpenModal = useCallback(() => {
        const infoProductAddonModal = orderProductAddonModal[productAddonType]
        setOpenModal({ allRowData: { ...allRowData, completeData, productAddonType, ...infoProductAddonModal, myType: 'Sell' }, type: 'editAddonProduct' })
    }, [setOpenModal, allRowData, completeData, productAddonType, orderProductAddonModal])
    if ((!allRowData['Product.hasComplements'] && !allRowData['Product.hasCategoryComplements'] ) || (allRowData?.OrderAddonGroupId && allRowData?.OrderProductId) || parseInt(String(productAddonType)) === ProductAddonTypeTyInversed['buyAddons']) {
        return null
    }
    return (
        <ITIconToolTip message={t('configAddon', 'Configurar complementos')} id={'addAddonQuote_'+allRowData.id} icon={faCog} onClick={myOpenModal}></ITIconToolTip>
    )
}
export default OrderEditAddonProduct